import { useQuery } from '@tanstack/react-query'
import type { GetCampaignByCampaignIdQueryVariables, Campaign } from '@twlvxtwlv/cms'
import { getCampaignByCampaignId } from '@twlvxtwlv/cms'

export function getUseCampaignOptions({
  id,
  locale,
  currentNftsPage,
  currentNftsPageSize,
}: GetCampaignByCampaignIdQueryVariables) {
  return {
    queryKey: ['campaign', { id }],
    queryFn: () =>
      getCampaignByCampaignId({
        locale,
        id,
        currentNftsPage,
        currentNftsPageSize,
      }),
    enabled: !!id,
  }
}

export function useCampaign(variables: GetCampaignByCampaignIdQueryVariables) {
  const res = useQuery(getUseCampaignOptions(variables))
  const campaignAttributes = res?.data?.campaigns?.data?.[0]?.attributes as Campaign | undefined

  return { campaignAttributes, ...res }
}
